import { api } from '../middleware/api';
import { sseClient } from '../../services/sseClient';

// Define endpoints using injectApi pattern
export const foecheckoutApi = api
  .enhanceEndpoints({ addTagTypes: ['FOECheckout'] })
  .injectEndpoints({
    endpoints: builder => ({
      getFOECheckouts: builder.query<any[], string>({
        query: cid => `foecheckout/${cid}`,
        providesTags: ['FOECheckout'],
        async onCacheEntryAdded(
          _arg,
          { cacheDataLoaded, cacheEntryRemoved, dispatch }
        ) {
          try {
            await cacheDataLoaded;
            const unsubscribe = sseClient.addListener(data => {
              if (
                data.type === 'FRONT_OFFICE_UPDATED' ||
                data.type === 'POS_ORDER_UPDATED'
              ) {
                dispatch(foecheckoutApi.util.invalidateTags(['FOECheckout']));
              }
            });
            await cacheEntryRemoved;
            unsubscribe();
          } catch {
            // no-op
          }
        }
      }),
      getFOECheckinById: builder.query<any, string>({
        query: id => `foecheckout/cibyid/${id}`,
        providesTags: ['FOECheckout']
      }),
      getFOECheckinByIdRooms: builder.query<any, any>({
        query: ({ id, rooms }) => `foecheckout/cibyidrooms/${id}/${rooms}`,
        providesTags: ['FOECheckout']
      }),
      getFOECheckoutById: builder.query<any, string>({
        query: id => `foecheckout/byid/${id}`,
        providesTags: ['FOECheckout']
      }),
      insertFOECheckout: builder.mutation({
        query: foecheckout => ({
          url: `foecheckout/`,
          method: 'POST',
          body: foecheckout
        }),
        invalidatesTags: ['FOECheckout']
      }),
      updateFOECheckout: builder.mutation({
        query: foecheckout => ({
          url: `foecheckout/`,
          method: 'PUT',
          body: foecheckout
        }),
        invalidatesTags: ['FOECheckout']
      }),
      update2FOECheckout: builder.mutation({
        query: ({ id, amt }) => ({
          url: `foecheckout/update`,
          method: 'PUT',
          body: { id: id, amt: Number(amt) > 0 ? amt : 900 }
        }),
        invalidatesTags: ['FOECheckout']
      }),
      updateFOECORecheckin: builder.mutation({
        query: foecheckout => ({
          url: `foecheckout/recheckin`,
          method: 'PUT',
          body: foecheckout
        }),
        invalidatesTags: ['FOECheckout']
      }),
      deleteFOECheckout: builder.mutation({
        query: foecheckout => ({
          url: `foecheckout/${foecheckout.co_id}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['FOECheckout']
      }),
      getFOECheckoutByDate: builder.query<any, any>({
        query: ({ cid, fdt, tdt }) => `foecheckout/bydate/${cid}/${fdt}/${tdt}`,
        providesTags: ['FOECheckout']
      })
    }),
    overrideExisting: true
  });

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetFOECheckoutsQuery,
  useGetFOECheckoutByIdQuery,
  useGetFOECheckinByIdQuery,
  useGetFOECheckinByIdRoomsQuery,
  useInsertFOECheckoutMutation,
  useUpdateFOECheckoutMutation,
  useUpdate2FOECheckoutMutation,
  useUpdateFOECORecheckinMutation,
  useDeleteFOECheckoutMutation,
  useGetFOECheckoutByDateQuery,
  useLazyGetFOECheckoutByDateQuery
} = foecheckoutApi;

